import { Button, Typography } from '@material-ui/core'
import { AddCircleOutline } from '@material-ui/icons'
import { makeStyles } from '@material-ui/styles'
import AsyncAutocomplete from 'components/AsyncAutocomplete'
import { isNull } from 'lodash'
import React from 'react'
import useTaskRequesters from '../hooks/useTaskRequesters'
import { filter } from 'lodash'
import { PersonAutocompleteOption } from 'volunteering/components/PersonAutocompleteOption'
import useTaskRecipients from '../hooks/useTaskRecipients'

const useStyles = makeStyles(theme => ({
  header: {
    display: 'inline-block',
    marginRight: theme.spacing(2),
  },
  headerRow: {
    verticalAlign: 'middle',
    display: 'flex',
  },
  personPicker: {
    margin: theme.spacing(2),
  },
}))

export default function TaskRequesterPicker(props) {
  const { value, onChange } = props
  const classes = useStyles()
  const { requesters, loading: requestersLoading, onOpenAddRequesterPrompt } = useTaskRequesters()
  const { recipients, loading: recipientsLoading } = useTaskRecipients()

  const handleChange = (e, value) => (!isNull(value) ? onChange(value) : onChange(undefined))

  const loading = requestersLoading || recipientsLoading
  const options = [...requesters, ...recipients]

  return (
    <div>
      <div className={classes.headerRow}>
        <Typography variant="h4" className={classes.header}>
          Requester
        </Typography>
        <Button variant="contained" onClick={onOpenAddRequesterPrompt} color="primary">
          <AddCircleOutline />
          Add
        </Button>
      </div>
      <AsyncAutocomplete
        options={options}
        getOptionLabel={opt => filter([opt.givenName, opt.familyName]).join(' ')}
        renderOption={opt => <PersonAutocompleteOption option={opt} />}
        onChange={handleChange}
        value={value}
        className={classes.personPicker}
        label="Requester"
        loading={loading}
      />
    </div>
  )
}
